import type { App } from "vue";
import { inject } from "vue";
import type { EdroneGtag, EdroneGtagDataLayerObject, SendEdroneGtagDataLayerObject } from "./edroneGtag";
import { ReactNativeBridge } from "vue-app/utils/reactNativeBridge";
import { getFlattenedEdroneContext } from "vue-app/utils/amplitude.ts";

/**
 *
 * @param eventName max 40 characters
 * @param parameters additional parameters to send to GA
 */
export function sendCustomEventToGA(eventName: string, parameters?: Record<string, string | number | boolean>) {
  if (typeof window.gtag === "function") {
    window.gtag?.("event", eventName.substring(0, 40), {
      ...parameters,
      ...getFlattenedEdroneContext(),
      is_paying: window.EDRONE_CONTEXT?.tracker?.isPaying || false,
      isMobileApp: ReactNativeBridge.checkIsWebViewMode(),
    });
  }
}

/**
 * DEPRECATED. This is the old approach.
 */
export function gtagUniversalSend(dataLayerObject: Record<"component_id", string>) {
  if (dataLayerObject.component_id && typeof window.gtag === "function") {
    window.gtag("event", "edrone_click", {
      component_id: dataLayerObject.component_id,
      is_paying: window.EDRONE_CONTEXT?.tracker?.isPaying || false,
      isMobileApp: ReactNativeBridge.checkIsWebViewMode(),
      ...getFlattenedEdroneContext(),
    });
  }
}

export const edroneGtag: EdroneGtag = {
  send(dataLayerObject) {
    gtagSend(dataLayerObject);
  },
};

if (typeof window !== "undefined") {
  window.edroneGtag = edroneGtag;
}

export default {
  install(app: App, options: EdroneGtag) {
    app.config.globalProperties.edroneGtag = edroneGtag;
    app.provide("edroneGtag", options);
  },
};

/**
 * DEPRECATED. This is the old approach.
 */
export function gtagSend(dataLayerObject: SendEdroneGtagDataLayerObject) {
  const defaultDataLayerObject: EdroneGtagDataLayerObject = {
    event: "button_click",
    component_type: "",
    component_variant: "",
    component_icon_name: "",
    component_state: "",
    component_label: "edrone",
    functionality_group: "",
    functionality: "",
    view: "",
    text: "",
    engagement_message_id: "",
    ai_subject_generated_id: "",
  };
  window.dataLayer?.push({
    ...defaultDataLayerObject,
    ...dataLayerObject,
    is_paying: window.EDRONE_CONTEXT?.tracker?.isPaying || false,
    isMobileApp: ReactNativeBridge.checkIsWebViewMode(),
    ...getFlattenedEdroneContext(),
  });
}

/**
 * This is necessary to work with the composition API. Probably can be removed after migration to Vue 3
 */
export function injectEdroneGtag(key = "edroneGtag", fallback?: EdroneGtag) {
  const resolved = inject(key, fallback);
  if (!resolved) {
    throw new Error(`Could not resolve ${key}`);
  }

  return resolved;
}
